import { Controller } from "@hotwired/stimulus";

/**
 * 直接指定の出品モーダルを表示する用
 */
export default class extends Controller {
  /**
   * お試し出品モーダルが表示されるように設定する
   */
  setTrialPublishingModal() {
    this.changeModalContentController.showModalContentByNameString(
      "trialPublishingConfirmation",
    );
  }

  /**
   * 本出品モーダルが表示されるように設定する
   */
  setPublishingModal() {
    this.changeModalContentController.showModalContentByNameString(
      "publishingConfirmation",
    );
  }

  connected({ detail: { content } }) {
    this.changeModalContentController = content;
  }
}
